import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { RutaProtegida } from './auth/RutaProtegida';
import { AppLayout } from './layout/AppLayout';
import { InicioRedirect } from './layout/InicioRedirect';
import { AltaPuertaScreen } from './admin/AltaPuertaScreen';
import { CodigosStaffScreen } from './admin/CodigosStaffScreen';
import { ConfigScreen } from './admin/ConfigScreen';
import { EquipoScreen } from './admin/EquipoScreen';
import { EventoDetalleLayout } from './admin/EventoDetalleLayout';
import { EventoResumenScreen } from './admin/EventoResumenScreen';
import { EventosListaScreen } from './admin/EventosListaScreen';
import { InvitadosScreen } from './admin/InvitadosScreen';
import { LotesScreen } from './admin/LotesScreen';
import { MesasScreen } from './admin/MesasScreen';
import { UsuariosScreen } from './admin/UsuariosScreen';
import { CheckInScreen } from './panel/CheckInScreen';
import { InvitadosDeAsesorScreen } from './panel/InvitadosDeAsesorScreen';
import { MisInvitacionesScreen } from './panel/MisInvitacionesScreen';
import { PanelEventoIndex } from './panel/PanelEventoIndex';
import { PanelEventoLayout } from './panel/PanelEventoLayout';
import { PanelInicioScreen } from './panel/PanelInicioScreen';
import { InvitacionScreen } from './screens/invitacion/InvitacionScreen';
import { LoginScreen } from './screens/LoginScreen';
import { PerfilScreen } from './screens/PerfilScreen';
import { StaffLoginScreen } from './screens/StaffLoginScreen';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/login/staff" element={<StaffLoginScreen />} />
          <Route path="/i/:token" element={<InvitacionScreen />} />

          <Route
            path="/"
            element={
              <RutaProtegida>
                <AppLayout />
              </RutaProtegida>
            }
          >
            <Route index element={<InicioRedirect />} />
            <Route path="perfil" element={<PerfilScreen />} />

            <Route
              path="admin"
              element={
                <RutaProtegida roles={['admin']}>
                  <EventosListaScreen />
                </RutaProtegida>
              }
            />
            <Route
              path="admin/usuarios"
              element={
                <RutaProtegida roles={['admin']}>
                  <UsuariosScreen />
                </RutaProtegida>
              }
            />
            <Route
              path="admin/eventos/:eventoId"
              element={
                <RutaProtegida roles={['admin']}>
                  <EventoDetalleLayout />
                </RutaProtegida>
              }
            >
              <Route index element={<EventoResumenScreen />} />
              <Route path="invitados" element={<InvitadosScreen />} />
              <Route path="equipo" element={<EquipoScreen />} />
              <Route path="lotes" element={<LotesScreen />} />
              <Route path="mesas" element={<MesasScreen />} />
              <Route path="alta-puerta" element={<AltaPuertaScreen />} />
              <Route path="codigos" element={<CodigosStaffScreen />} />
              <Route path="config" element={<ConfigScreen />} />
            </Route>

            <Route
              path="panel"
              element={
                <RutaProtegida roles={['asesor', 'staff']}>
                  <PanelInicioScreen />
                </RutaProtegida>
              }
            />
            <Route
              path="panel/:eventoId"
              element={
                <RutaProtegida roles={['asesor', 'staff']}>
                  <PanelEventoLayout />
                </RutaProtegida>
              }
            >
              <Route index element={<PanelEventoIndex />} />
              <Route path="invitaciones" element={<MisInvitacionesScreen />} />
              <Route path="invitados" element={<InvitadosDeAsesorScreen />} />
              <Route path="check-in" element={<CheckInScreen />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
